import { Stack } from '@mui/system';
import { getRuntimeUrl } from '@common/services/storage';
import React from 'react';

interface EmptyStateProps {
  description?: string;
  variant?: 'small' | 'large';
}

const EmptyState = React.memo(({ 
  description = '', 
  variant = 'large'
}: EmptyStateProps) => {
  const defaultImageSrc = getRuntimeUrl("/img/no-audiences-found.svg");
  
  const config = {
    small: {
      imageHeight: '60px',
      fontSize: '14px',
      fontWeight: 500,
      color: 'text.secondary',
      padding: '20px 16px'
    },
    large: {
      imageHeight: '120px',
      fontSize: '16px',
      fontWeight: 700,
      color: 'inherit',
      padding: '22px'
    }
  };

  const styles = config[variant];

  return (
    <Stack
      sx={{
        justifyContent: 'center',
        alignItems: 'center',
        padding: styles.padding,
      }}>
      <img 
        src={defaultImageSrc} 
        alt="" 
        style={{ 
          height: styles.imageHeight, 
          marginBottom: '12px' 
        }} 
      />
      <span 
        style={{ 
          fontSize: styles.fontSize, 
          fontWeight: styles.fontWeight,
          color: styles.color,
          marginBottom: variant === 'large' ? '16px' : undefined
        }}>
        {description}
      </span>
    </Stack>
  );
});

export default EmptyState; 